import React from "react";
import { paintUrgency } from "@/lib/paintApi";

const STYLES = {
  green: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  yellow: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  red: "bg-red-100 text-red-800 border-red-300 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800",
};

/**
 * Green / yellow / red urgency pill for paint queue rows and per-item
 * badges. Colours are governed by /api/paint/settings thresholds.
 */
export default function PaintUrgencyPill({ daysOut, thresholds, className = "", testId }) {
  const level = paintUrgency(daysOut, thresholds);
  const label = `${Math.max(0, Math.floor(daysOut || 0))}d`;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-black rounded-md px-2 py-1 border whitespace-nowrap ${STYLES[level]} ${className}`}
      data-testid={testId}
      title={`${label} at painter · ${level.toUpperCase()}`}
    >
      {label}
    </span>
  );
}
